export default "__VITE_ASSET__D$FTk8LT__";